module.exports = __webpack_public_path__ + "img/document-icon-dark.d4ca45d9.svg";